import React, { useEffect, useState, useCallback } from 'react';
import { Table, Tag, Space, Link} from '@arco-design/web-react';
import { useNavigate } from 'react-router-dom';
import '@arco-design/web-react/dist/css/arco.css';
import HomeHeader from '../Components/Home/HomeHeader';
import HomeTipCard from '../Components/Home/HomeTipCard';
import HomeToolbar from '../Components/Home/HomeToolbar';
import HomePagination from '../Components/Home/HomePagination';
import { PlatformIcon } from '../Components/Analysis/AnalysisComponents';
import { useHomeApi } from '../services/useHomeApi';
import { getQuote,getTaskListApi } from '../Api/api';
export default function Home() {
 // ========== 1.1 自定义 Hook 获取业务数据和方法 ==========
  const {
    loading,
    tasks,
    total,
    currentPage,    // 从 hook 获取当前页
    pageSize,       // 从 hook 获取页大小
    fetchTasks,
    fetchStats,
    fetchComments,
    handlePageChange, // 从 hook 获取分页处理函数
  } = useHomeApi();
 // ========== 1.2 本地状态 ==========
 const [pluginDetected, setPluginDetected] = useState(false);
 const [quota, setQuota] = useState({ used_quota: 0, total_quota: 0 });
 const [intentTotal, setIntentTotal] = useState(0); // 统计意向总数
 const token = localStorage.getItem('token');
  // ========== 2. 副作用：数据获取、插件检测 ==========
  // 2.1 获取任务列表和统计数据
  useEffect(() => {
    fetchTasks();
    fetchStats();
  }, []);
  // 2.2 获取评论收集额度
  useEffect(() => {
    async function fetchQuota() {
      try {
        const res = await getQuote();
        if (res && res.status === 200 && res.data) {
          setQuota({
            used_quota: res.data.used_quota,
            total_quota: res.data.total_quota,
          });
        }
      } catch {
        setQuota({ used_quota: 0, total_quota: 0 });
      }
    }
    fetchQuota();
  }, []);
 // 2.3 统计意向客户总数（复用已有的任务数据，避免重复请求）
 useEffect(() => {
  if (tasks && tasks.length > 0) {
    const total = tasks.reduce(
      (sum, task) => sum + (task.intent_count || 0),
      0
    );
    setIntentTotal(total);
  }
}, [tasks]);

 // 2.4 检测插件
 useEffect(() => {
  function checkPlugin() {
    setPluginDetected(!!window.__MY_PLUGIN_INSTALLED__);
  }
  checkPlugin();
  const timer = setInterval(checkPlugin, 1000);
  return () => clearInterval(timer);
}, []);

// ========== 3. 事件处理函数 ==========
  // 3.2 获取评论
  const handleFetchComments = async (taskId) => {
    const result = await fetchComments(taskId, 1, 10, null);
    if (result.success) {
      // 这里可以处理评论数据，比如显示在弹窗中

    }
  };

 // 在 Home.js 中修改回调函数
const handleCurrentPageChange = useCallback((page) => {
  
  handlePageChange(page, pageSize);
}, [handlePageChange, pageSize]); // 保留依赖

const handlePageSizeChange = useCallback((size) => {
  
  handlePageChange(currentPage, size);
}, [handlePageChange, currentPage]); // 保留依赖

   // ========== 4. 表格列配置 ==========
   const navigate = useNavigate();
  const columns = [
    { 
      title: '关键词', 
      dataIndex: 'keyword',
      key: 'keyword'
    },
    { 
      title: '平台', 
      dataIndex: 'platform', 
      key: 'platform',
      render: val => <PlatformIcon platform={val} /> 
    },
    { 
      title: '评论收集与数量', 
      dataIndex: 'crawler_state', 
      key: 'crawler_state_and_progress',
      render: (_, record) => (
        <span>
          <Tag color={record.crawler_state === 'finish' ? 'green' : 'orange'}>
            {record.crawler_state === 'finish' ? '已完成' : '进行中'}
          </Tag>
          <span style={{ marginLeft: 8 }}>
            {record.crawler_progress}条
          </span>
        </span>
      ) 
    },
    {
      title: '评论分析与数量',
      key: 'analysis_state_and_progress',
      render: (_, record) => (
        <span>
          <Tag color={record.analysis_state === 'finish' ? 'green' : 'orange'}>
            {record.analysis_state === 'finish' ? '已完成' : '进行中'}
          </Tag>
          <span style={{ marginLeft: 8 }}>
            {record.analysis_progress}条
          </span>
        </span>
      )
    },
    { 
      title: '意向客户', 
      dataIndex: 'intent_count', 
      key: 'intent_count',
      render: val => <Tag color="green">{val}人</Tag>
    },
    {
      title: '私信客户',
      dataIndex: 'market_progress',
      key: 'market_progress',
      render: val => <Tag color="blue">{val}人</Tag>
    },
    { 
      title: '创建时间', 
      dataIndex: 'create_time', 
      key: 'create_time',
      render: val => <span>{new Date(val).toLocaleString()}</span>
    },
   
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size={8}>
         <Link
          href={`/analysis/${record.task_id}`}
          onClick={e => {
            e.preventDefault();
            navigate(`/analysis/${record.task_id}`);
          }}
        >
          进入分析
        </Link>
        </Space>
      )
    }
  ];

  return (
    <div>
      <HomeHeader />
      {!pluginDetected && <HomeTipCard />}
      <div style={{ width: '100%' }}>
      <HomeToolbar pluginDetected={pluginDetected} />
      </div>
      <div style={{ margin: '-18px 20px 20px 20px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 16,
            height: 32
          }}
        >
         <div style={{ display: 'flex', alignItems: 'center' }}>
        {/* 左侧：任务列表标题 */}
        <h2 style={{ margin: 0, fontWeight: 600, textAlign: 'left' }}>任务列表</h2>
        
        {/* 中间：统计数据 */}
        <div
          style={{
            color: '#888',
            fontSize: 14,
            marginLeft: 16, // 控制标题和统计数据的间距
            display: 'flex',
            alignItems: 'center'
          }}
        >
      意向总数：{intentTotal}个&nbsp;  评论收集额度：{quota.used_quota}/{quota.total_quota}
        </div>
      </div>
          
          {/* 右侧：分页器 - 修改调用方式 */}
          <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <HomePagination
              currentPage={currentPage}
              pageSize={pageSize}
              total={total}
              setCurrentPage={handleCurrentPageChange}
              setPageSize={handlePageSizeChange}
            />
          </div>
        </div>
        <Table 
          columns={columns} 
          data={tasks} 
          pagination={false}
          loading={loading}
          rowKey="task_id"
        />
      </div>
    </div>
  );
}